<template>
  <div>
    <Table
      :columns="columns"
      :data="resources"
      size="small"
      highlight-row
      stripe
      max-height="700"
    >
      <template slot-scope="{ row }" slot="barcode">
        <span>
          {{ row.product ? row.product.barcode : 'N/A' }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="product">
        <span>
          {{ row.product ? row.product.product_name_en : 'N/A' }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="uom">
        <span>
          {{ row.unite_of_measure ? row.unite_of_measure.uom_name_en : 'N/A' }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="unit_price">
        <ts-display-currency
          :amount="row.input_unit_price"
          :currency_id="row.currency_id"
        />
      </template>
      <template slot-scope="{ row }" slot="total">
        <ts-display-currency
          :amount="row.total"
          :currency_id="row.currency_id"
        />
      </template>
      <template slot-scope="{ row }" slot="max_reorder">
        {{
          row.product.maximum_reorder_allow
            ? row.product.maximum_reorder_allow
            : 0
        }}
      </template>
      <template slot-scope="{ row }" slot="allow_order">
        <span
          class="badge badge-success"
          v-if="
            row.quantity_order >
              (row.product.maximum_reorder_allow
                ? row.product.maximum_reorder_allow
                : 0)
          "
          >Yes</span
        >
        <span class="badge badge-danger" v-else>No</span>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  name: 'tableExpand',
  props: {
    row: Object
  },
  data() {
    return {}
  },
  computed: {
    resources() {
      return this.row.details
    },
    columns() {
      return [
        {
          title: this.$t('purchaseRequest.barcode'),
          slot: 'barcode',
          minWidth: 90,
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.productName'),
          slot: 'product',
          minWidth: 180,
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.uom'),
          slot: 'uom',
          minWidth: 70,
          align: 'center'
        },
        {
          title: this.$t('purchaseRequest.quantity'),
          key: 'quantity',
          minWidth: 130,
          sortable: true,
          align: 'center'
        },
        {
          title: this.$t('purchaseRequest.cost'),
          slot: 'unit_price',
          minWidth: 130,
          sortable: true,
          align: 'right'
        },
        {
          title: this.$t('purchaseRequest.total'),
          slot: 'total',
          minWidth: 130,
          sortable: true,
          align: 'right'
        },
        {
          title: this.$t('purchaseRequest.maxReorder'),
          slot: 'max_reorder',
          minWidth: 130,
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('purchaseRequest.alloworder'),
          slot: 'allow_order',
          minWidth: 130,
          align: 'center',
          sortable: true
        }
      ]
    }
  },
  methods: {}
}
</script>
